var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('StandardChart',{attrs:{"input":_vm.chartData,"maxWidth":"100%","chartType":"bar","loading":_vm.loading,"showDownload":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }